// import React, { useState, useEffect, useMemo } from "react";
// import { TextField, MenuItem, Grid, Typography, Button, Collapse, Chip, CircularProgress } from "@mui/material";
// import { FilterList as FilterListIcon } from "@mui/icons-material";
// import axios from "axios";
// import NonConformanceTable from './NonConformanceTable';

// // Form mappings: UI display name to API name
// const formMappings = {
//   "Pre-Lamination": "PreLamination",
//   "Post-Lamination": "PostLamination",
//   "Bill of material verification": "BOM",
//   "Stringer": "Stringer",
//   "Lamination machine parameters verification": "LaminationMachine",
//   "Calibration data verification of secondary module": "calibrationVerificationOfSecondaryModule",
//   "Primary (Golden) Module Calibration record": "PrimaryModuleCalibrationRecord",
//   "Frame sealant weight verification": "FrameSealantWeightVerification",
//   "Junction Box sealant weight verification": "JunctionBoxSealantWeightVerification",
//   "Junction Box Potting material ratio verification": "JunctionBoxPottingMaterial",
//   "Module dimensions check": "ModuleDimensionCheck",
// };

// // Mapping of form names to their subform mappings
// const subFormMappingsByForm = {
//   "Pre-Lamination": {
//     "Shop Floor": "shopFloor_pre",
//     "Cell and Cutting Machine": "CellAndCuttingMachine_pre",
//     "Encapsulation Material (Front)": "encapsulationMaterialFront_pre",
//     "Encapsulation Material (Back)": "encapsulationMaterialBack_pre",
//     "Glass (Front & Back)": "GlassFrontBack_pre",
//     "Tabbing & Stringing": "TabbingStringing_pre",
//     "Auto Bussing": "autoBussing_pre",
//     "Barcode/RFID": "barCodeRFID_pre",
//     "Pre-Lamination EL & Re-work": "PreLaminationELRework_pre",
//   },
//   "Post-Lamination": {
//     "Lamination": "Lamination_post",
//     "Trimming/VI at 90 Degree": "Trimming_post",
//     "Framing": "Framing_post",
//     "JB Assembling & Soldering": "JbAssemblingSoldering_post",
//     "Curing": "Curing_post",
//     "Cleaning": "Cleaning_post",
//     "Electrical Test": "electricalTest_post",
//     "HiPot": "HiPot_post",
//     "Post-Lamination EL": "PostLaminationEL_post",
//     "Visual Inspection": "VisualInspections_post",
//     "Packing": "Packing_post",
//   },
//   "Bill of material verification": {
//     "Adhesive Sealant": "AdhesiveSealant",
//     "Cell": "Cell",
//     "Frame": "Frame",
//     "Cell Fixing Type": "cellFixingType",
//     "EVA Back": "evaBack",
//     "EVA Front": "evaFront",
//     "Flux": "flux",
//     "Glass Back": "glassBack",
//     "Glass Front": "glassFront",
//     "Interconnector": "interconnector",
//     "Junction Box": "junctionBox",
//     "Potting Material": "pottingMaterial",
//     "String Connector": "stringConnector",
//   },
// };

// const NonConformanceReport = () => {
//   const [supplier, setSupplier] = useState("");
//   const [shift, setShift] = useState([]);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [formName, setFormName] = useState([]);
//   const [subForm, setSubForm] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [supplierShifts, setSupplierShifts] = useState([]);
//   const [showFilters, setShowFilters] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [availableSubForms, setAvailableSubForms] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   // Form names for UI display
//   const formNames = Object.keys(formMappings);

//   // Inverse form mappings: API to UI
//   const inverseFormMappings = Object.fromEntries(
//     Object.entries(formMappings).map(([ui, api]) => [api, ui])
//   );

//   // Combine all subform mappings for inverse lookup
//   const allSubFormMappings = Object.values(subFormMappingsByForm).reduce(
//     (acc, curr) => ({ ...acc, ...curr }),
//     {}
//   );

//   const inverseSubFormMappings = Object.fromEntries(
//     Object.entries(allSubFormMappings).map(([ui, api]) => [api, ui])
//   );

//   // Fetch suppliers when the component mounts
//   useEffect(() => {
//     const fetchSuppliers = async () => {
//       try {
//         const selectedProject = localStorage.getItem("selectedProject");
//         if (!selectedProject) {
//           setError("Project ID not found in local storage");
//           return;
//         }

//         const response = await apiClient.post(`get_supplier_names`, {
//           projectId: selectedProject,
//         });

//         if (!Array.isArray(response.data)) {
//           setError("Invalid response format from supplier API");
//           return;
//         }

//         const supplierData = response.data
//           .map((info) => {
//             if (!info.name) {
//               console.warn("Skipping invalid supplier entry:", info);
//               return null;
//             }
//             return {
//               name: info.name,
//               shift: info.shift,
//             };
//           })
//           .filter(Boolean);

//         setSuppliers(supplierData);
//       } catch (error) {
//         setError("Error collecting supplier information");
//         console.error("Supplier fetch error:", error);
//       }
//     };
//     fetchSuppliers();
//   }, []);

//   // Handle supplier change
//   const handleSupplierChange = (e) => {
//     const selectedSupplierName = e.target.value;
//     setSupplier(selectedSupplierName);
//     setShift([]);

//     const selectedSupplierData = suppliers.find((sup) => sup.name === selectedSupplierName);
//     if (selectedSupplierData) {
//       const shiftOptions =
//         selectedSupplierData.shift === "MorningAfternoonNight"
//           ? ["Morning", "Afternoon", "Night"]
//           : ["Day", "Night"];
//       setSupplierShifts(shiftOptions);
//     } else {
//       setSupplierShifts([]);
//     }
//   };

//   // Handle form name change
//   const handleFormNameChange = (e) => {
//     const selectedForms = e.target.value;
//     setFormName(selectedForms);
//     setSubForm([]); // Reset subForm when formName changes
//   };

//   // Filter subForm when availableSubForms changes
//   useEffect(() => {
//     setSubForm((prev) => prev.filter((sub) => availableSubForms.includes(sub)));
//   }, [availableSubForms]);

//   // Fetch data when dependencies change (excluding subForm), with debounce
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       const fetchData = async () => {
//         const projectId = localStorage.getItem("selectedProject");
//         if (!projectId || !supplier || shift.length === 0 || !startDate || !endDate || formName.length === 0) {
//           setTableData([]);
//           setAvailableSubForms([]);
//           return;
//         }

//         setLoading(true);
//         setError(null);

//         try {
//           const apiFormNames = formName.map((name) => formMappings[name]);

//           const response = await apiClient.get(`ncr`, {
//             params: {
//               projectId,
//               inspectionSupplier: supplier,
//               inspectionShift: shift.join(","),
//               date: startDate,
//               endDate: endDate,
//               formName: apiFormNames.join(","),
//             },
//           });

//           if (response.data.status === "success" && Array.isArray(response.data.data)) {
//             // Ensure remark field is present, default to empty string if missing
//             const processedData = response.data.data.map((item) => ({
//               ...item,
//               remark: item.remark || '',
//             }));
//             setTableData(processedData);

//             // Extract unique subforms from data
//             const uniqueApiSubForms = [...new Set(processedData.map((item) => item.subform || '').filter(Boolean))];

//             // Get allowed subforms in the original mapped order
//             const orderedUiSubForms = [];
//             const seen = new Set();

//             for (const form of formName) {
//               const subFormMap = subFormMappingsByForm[form] || {};
//               for (const [uiName, apiName] of Object.entries(subFormMap)) {
//                 if (uniqueApiSubForms.includes(apiName) && !seen.has(uiName)) {
//                   seen.add(uiName);
//                   orderedUiSubForms.push(uiName);
//                 }
//               }
//             }

//             setAvailableSubForms(orderedUiSubForms); // Preserves original mapping order
//           } else {
//             setError(response.data.message || "Failed to fetch data");
//             setTableData([]);
//             setAvailableSubForms([]);
//           }
//         } catch (error) {
//           setError("Failed to fetch data");
//           console.error("Fetch error:", error);
//           setTableData([]);
//           setAvailableSubForms([]);
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchData();
//     }, 500); // Debounce by 500ms

//     return () => clearTimeout(timer);
//   }, [endDate, supplier, shift, startDate, formName]);

//   // Compute filtered data based on selected subForms (client-side)
//   const filteredData = useMemo(() => {
//     if (subForm.length === 0) return tableData;

//     const selectedApiSubForms = subForm.map((ui) => allSubFormMappings[ui]).filter(Boolean);
//     return tableData.filter((item) => selectedApiSubForms.includes(item.subform));
//   }, [tableData, subForm, allSubFormMappings]);

//   // Toggle filter visibility
//   const toggleFilters = () => {
//     setShowFilters((prev) => !prev);
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <Typography variant="h5" gutterBottom>
//         Non-Conformance Report
//       </Typography>

//       <Button
//         variant="outlined"
//         startIcon={<FilterListIcon />}
//         onClick={toggleFilters}
//         style={{ marginBottom: "20px" }}
//       >
//         {showFilters ? "Hide Filters" : "Show Filters"}
//       </Button>

//       <Collapse in={showFilters}>
//         <Grid container spacing={2} style={{ marginBottom: "20px" }}>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               select
//               label="Supplier"
//               value={supplier}
//               onChange={handleSupplierChange}
//               fullWidth
//               size="small"
//             >
//               {suppliers.map((option) => (
//                 <MenuItem key={option.name} value={option.name}>
//                   {option.name}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               select
//               label="Shift"
//               value={shift}
//               onChange={(e) => setShift(e.target.value)}
//               fullWidth
//               size="small"
//               disabled={!supplier}
//               SelectProps={{
//                 multiple: true,
//                 renderValue: (selected) => (
//                   <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
//                     {selected.map((value) => (
//                       <Chip key={value} label={value} size="small" />
//                     ))}
//                   </div>
//                 ),
//               }}
//             >
//               {supplierShifts.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               label="Start Date"
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               fullWidth
//               size="small"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               label="End Date"
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               fullWidth
//               size="small"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               select
//               label="Form Name"
//               value={formName}
//               onChange={handleFormNameChange}
//               fullWidth
//               size="small"
//               SelectProps={{
//                 multiple: true,
//                 renderValue: (selected) => (
//                   <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
//                     {selected.map((value) => (
//                       <Chip key={value} label={value} size="small" />
//                     ))}
//                   </div>
//                 ),
//               }}
//             >
//               {formNames.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               select
//               label="Sub Form"
//               value={subForm}
//               onChange={(e) => setSubForm(e.target.value)}
//               fullWidth
//               size="small"
//               disabled={availableSubForms.length === 0}
//               SelectProps={{
//                 multiple: true,
//                 renderValue: (selected) => (
//                   <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
//                     {selected.map((value) => (
//                       <Chip key={value} label={value} size="small" />
//                     ))}
//                   </div>
//                 ),
//               }}
//             >
//               {availableSubForms.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>
//         </Grid>
//       </Collapse>

//       {loading && (
//         <div style={{ textAlign: "center", margin: "20px 0" }}>
//           <CircularProgress />
//         </div>
//       )}
//       {error && (
//         <Typography color="error" align="center" style={{ margin: "20px 0" }}>
//           {error}
//         </Typography>
//       )}
//       <NonConformanceTable
//         data={filteredData}
//         selectedForms={formName}
//         formMappings={formMappings}
//         selectedShifts={shift}
//       />
//     </div>
//   );
// };

// export default NonConformanceReport;

import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
  Paper,
  Tabs,
  Tab,
  Chip,
  Fade,
} from "@mui/material";
import {
  FilterList as FilterListIcon,
  FilterListOff as FilterListOffIcon,
  RestartAlt as ResetIcon,
  AssessmentOutlined as ReportIcon,
  TableChartOutlined as TableIcon,
  KeyboardArrowDown,
  Search,
} from "@mui/icons-material";
import NonConformanceTable from "./NonConformanceTable";
import apiClient from "../../pages/keycloak/axiosInstance";

// Form mappings: UI display name to API name
const formMappings = {
  "Pre-Lamination": "PreLamination",
  "Post-Lamination": "PostLamination",
  "Bill of material verification": "BOM",
  Stringer: "Stringer",
  "Lamination machine parameters verification": "LaminationMachine",
  "Calibration data verification of secondary module": "calibrationVerificationOfSecondaryModule",
  "Primary (Golden) Module Calibration record": "PrimaryModuleCalibrationRecord",
  "Frame sealant weight verification": "FrameSealantWeightVerification",
  "Junction Box sealant weight verification": "JunctionBoxSealantWeightVerification",
  "Junction Box Potting material ratio verification": "JunctionBoxPottingMaterial",
  "Module dimensions check": "ModuleDimensionCheck",
};

// Mapping of form names to their subform mappings
const subFormMappingsByForm = {
  "Pre-Lamination": {
    "Shop Floor": "shopFloor_pre",
    "Cell and Cutting Machine": "CellAndCuttingMachine_pre",
    "Encapsulation Material (Front)": "encapsulationMaterialFront_pre",
    "Encapsulation Material (Back)": "encapsulationMaterialBack_pre",
    "Glass (Front & Back)": "GlassFrontBack_pre",
    "Tabbing & Stringing": "TabbingStringing_pre",
    "Auto Bussing": "autoBussing_pre",
    "Barcode/RFID": "barCodeRFID_pre",
    "Pre-Lamination EL & Re-work": "PreLaminationELRework_pre",
  },
  "Post-Lamination": {
    Lamination: "Lamination_post",
    "Trimming/VI at 90 Degree": "Trimming_post",
    Framing: "Framing_post",
    "JB Assembling & Soldering": "JbAssemblingSoldering_post",
    Curing: "Curing_post",
    Cleaning: "Cleaning_post",
    "Electrical Test": "electricalTest_post",
    HiPot: "HiPot_post",
    "Post-Lamination EL": "PostLaminationEL_post",
    "Visual Inspection": "VisualInspections_post",
    Packing: "Packing_post",
  },
  "Bill of material verification": {
    "Adhesive Sealant": "AdhesiveSealant",
    Cell: "Cell",
    Frame: "Frame",
    "Cell Fixing Type": "cellFixingType",
    "EVA Back": "evaBack",
    "EVA Front": "evaFront",
    Flux: "flux",
    "Glass Back": "glassBack",
    "Glass Front": "glassFront",
    Interconnector: "interconnector",
    "Junction Box": "junctionBox",
    "Potting Material": "pottingMaterial",
    "String Connector": "stringConnector",
  },
};

/* -------------------------------------------------------------
   CUSTOM REUSABLE MULTI-SELECT DROPDOWN
------------------------------------------------------------- */
const CustomMultiSelect = ({
  label,
  options = [],
  value = [],
  onChange,
  disabled = false,
  placeholder = "Select options...",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = useMemo(() => {
    if (!searchTerm.trim()) return options;
    return options.filter((opt) =>
      opt.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [options, searchTerm]);

  const isAllSelected = options.length > 0 && value.length === options.length;

  const handleToggleOption = (option) => {
    if (value.includes(option)) {
      onChange(value.filter((item) => item !== option));
    } else {
      onChange([...value, option]);
    }
  };

  const handleToggleAll = () => {
    if (isAllSelected) {
      onChange([]);
    } else {
      onChange([...options]);
    }
  };

  return (
    <div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
      <label
        style={{
          display: "block",
          fontSize: "12px",
          fontWeight: 600,
          color: "#475569",
          marginBottom: "6px",
        }}
      >
        {label}
      </label>

      <button
        type="button"
        disabled={disabled}
        onClick={() => setIsOpen((prev) => !prev)}
        style={{
          width: "100%",
          minHeight: "40px",
          padding: "6px 12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: disabled ? "#f8fafc" : "#ffffff",
          border: isOpen ? "1.5px solid #2563eb" : "1px solid #cbd5e1",
          borderRadius: "8px",
          cursor: disabled ? "not-allowed" : "pointer",
          outline: "none",
          transition: "all 0.15s ease",
          boxShadow: isOpen ? "0 0 0 3px rgba(37, 99, 235, 0.12)" : "none",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexWrap: "wrap",
            overflow: "hidden",
          }}
        >
          {value.length === 0 ? (
            <span style={{ color: "#94a3b8", fontSize: "13px" }}>{placeholder}</span>
          ) : value.length <= 1 ? (
            <span
              style={{
                backgroundColor: "#eff6ff",
                color: "#1d4ed8",
                fontSize: "12px",
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: "4px",
              }}
            >
              {value[0]}
            </span>
          ) : (
            <>
              <span
                style={{
                  backgroundColor: "#eff6ff",
                  color: "#1d4ed8",
                  fontSize: "12px",
                  fontWeight: 600,
                  padding: "2px 8px",
                  borderRadius: "4px",
                }}
              >
                {value[0]}
              </span>
              <span
                style={{
                  backgroundColor: "#f1f5f9",
                  color: "#475569",
                  fontSize: "12px",
                  fontWeight: 600,
                  padding: "2px 6px",
                  borderRadius: "4px",
                }}
              >
                +{value.length - 1} more
              </span>
            </>
          )}
        </div>
        <KeyboardArrowDown
          style={{
            fontSize: "18px",
            color: "#64748b",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </button>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            width: "100%",
            minWidth: "240px",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            boxShadow:
              "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
            zIndex: 100,
            overflow: "hidden",
          }}
        >
          {options.length > 5 && (
            <div
              style={{
                padding: "8px",
                borderBottom: "1px solid #f1f5f9",
                position: "relative",
              }}
            >
              <Search
                style={{
                  position: "absolute",
                  left: "16px",
                  top: "16px",
                  fontSize: "16px",
                  color: "#94a3b8",
                }}
              />
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 10px 6px 30px",
                  fontSize: "12px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 12px",
              backgroundColor: "#f8fafc",
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "12px",
                fontWeight: 600,
                color: "#1e293b",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleToggleAll}
                style={{
                  accentColor: "#2563eb",
                  cursor: "pointer",
                  width: "15px",
                  height: "15px",
                }}
              />
              {isAllSelected ? "Deselect All" : "Select All"}
            </label>
            <span style={{ fontSize: "11px", color: "#64748b", fontWeight: 500 }}>
              {value.length}/{options.length}
            </span>
          </div>

          <div style={{ maxHeight: "200px", overflowY: "auto", padding: "4px 0" }}>
            {filteredOptions.length === 0 ? (
              <div
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                }}
              >
                No options found
              </div>
            ) : (
              filteredOptions.map((option) => {
                const checked = value.includes(option);
                return (
                  <div
                    key={option}
                    onClick={() => handleToggleOption(option)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "7px 12px",
                      fontSize: "13px",
                      color: checked ? "#1d4ed8" : "#334155",
                      backgroundColor: checked ? "#eff6ff" : "transparent",
                      cursor: "pointer",
                      transition: "background 0.1s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!checked) e.currentTarget.style.backgroundColor = "#f8fafc";
                    }}
                    onMouseLeave={(e) => {
                      if (!checked) e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => {}}
                      style={{
                        accentColor: "#2563eb",
                        cursor: "pointer",
                        width: "14px",
                        height: "14px",
                      }}
                    />
                    <span
                      style={{
                        flex: 1,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {option}
                    </span>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

/* -------------------------------------------------------------
   CUSTOM SINGLE-SELECT & DATE COMPONENTS
------------------------------------------------------------- */
const CustomSingleSelect = ({
  label,
  value,
  options = [],
  onChange,
  placeholder = "Select...",
}) => (
  <div style={{ width: "100%" }}>
    <label
      style={{
        display: "block",
        fontSize: "12px",
        fontWeight: 600,
        color: "#475569",
        marginBottom: "6px",
      }}
    >
      {label}
    </label>
    <div style={{ position: "relative" }}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%",
          height: "40px",
          padding: "6px 28px 6px 12px",
          fontSize: "13px",
          color: value ? "#1e293b" : "#94a3b8",
          backgroundColor: "#ffffff",
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          outline: "none",
          appearance: "none",
          cursor: "pointer",
        }}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option
            key={opt.value || opt}
            value={opt.value || opt}
            style={{ color: "#1e293b" }}
          >
            {opt.label || opt}
          </option>
        ))}
      </select>
      <KeyboardArrowDown
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: "18px",
          color: "#64748b",
          pointerEvents: "none",
        }}
      />
    </div>
  </div>
);

const CustomDateInput = ({ label, value, onChange }) => (
  <div style={{ width: "100%" }}>
    <label
      style={{
        display: "block",
        fontSize: "12px",
        fontWeight: 600,
        color: "#475569",
        marginBottom: "6px",
      }}
    >
      {label}
    </label>
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: "100%",
        height: "40px",
        padding: "6px 10px",
        fontSize: "13px",
        color: value ? "#1e293b" : "#94a3b8",
        backgroundColor: "#ffffff",
        border: "1px solid #cbd5e1",
        borderRadius: "8px",
        outline: "none",
        boxSizing: "border-box",
      }}
    />
  </div>
);

/* -------------------------------------------------------------
   MAIN COMPONENT
------------------------------------------------------------- */
const NonConfermanceReport = () => {
  const [supplier, setSupplier] = useState("");
  const [shift, setShift] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [formName, setFormName] = useState([]);
  const [subForm, setSubForm] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [supplierShifts, setSupplierShifts] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [availableSubForms, setAvailableSubForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);

  const formNames = useMemo(() => Object.keys(formMappings), []);

  const inverseFormMappings = useMemo(
    () => Object.fromEntries(Object.entries(formMappings).map(([ui, api]) => [api, ui])),
    []
  );

  const allSubFormMappings = useMemo(
    () =>
      Object.values(subFormMappingsByForm).reduce(
        (acc, curr) => ({ ...acc, ...curr }),
        {}
      ),
    []
  );

  const projectId = localStorage.getItem("selectedProject");

  // Keep active tab index within bounds when form selection changes
  useEffect(() => {
    if (selectedTab >= formName.length) {
      setSelectedTab(0);
    }
  }, [formName, selectedTab]);

  // Fetch suppliers on mount
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        if (!projectId) {
          setError("Project ID not found in local storage");
          return;
        }

        const response = await apiClient.post(`get_supplier_names`, {
          projectId,
        });

        if (!Array.isArray(response.data)) {
          setError("Invalid response format from supplier API");
          return;
        }

        const supplierData = response.data
          .filter((info) => Boolean(info?.name))
          .map((info) => ({
            name: info.name,
            shift: info.shift,
          }));

        setSuppliers(supplierData);
      } catch (err) {
        setError("Error collecting supplier information");
        console.error("Supplier fetch error:", err);
      }
    };
    fetchSuppliers();
  }, [projectId]);

  // Allowed suppliers filtered by Keycloak user roles
  const allowedSuppliers = useMemo(() => {
    if (!projectId) return [];
    const userRoles = JSON.parse(sessionStorage.getItem("userRoles") || "[]");
    return suppliers.filter((item) =>
      userRoles.includes(`${projectId}_${item.name}_view`)
    );
  }, [suppliers, projectId]);

  const handleSupplierChange = (selectedSupplierName) => {
    setSupplier(selectedSupplierName);
    setShift([]);

    const selectedSupplierData = suppliers.find(
      (sup) => sup.name === selectedSupplierName
    );
    if (selectedSupplierData) {
      const shiftOptions =
        selectedSupplierData.shift === "MorningAfternoonNight"
          ? ["Morning", "Afternoon", "Night"]
          : ["Day", "Night"];
      setSupplierShifts(shiftOptions);
    } else {
      setSupplierShifts([]);
    }
  };

  const handleFormNameChange = (newFormSelection) => {
    setFormName(newFormSelection);
    setSubForm([]);
  };

  // Sync subForm selections with newly available subforms
  useEffect(() => {
    setSubForm((prev) => prev.filter((sub) => availableSubForms.includes(sub)));
  }, [availableSubForms]);

  const handleClearFilters = () => {
    setSupplier("");
    setShift([]);
    setStartDate("");
    setEndDate("");
    setFormName([]);
    setSubForm([]);
    setTableData([]);
    setAvailableSubForms([]);
    setError(null);
  };

  // Debounced API request
  useEffect(() => {
    const timer = setTimeout(() => {
      const fetchData = async () => {
        if (
          !projectId ||
          !supplier ||
          shift.length === 0 ||
          !startDate ||
          !endDate ||
          formName.length === 0
        ) {
          setTableData([]);
          setAvailableSubForms([]);
          return;
        }

        setLoading(true);
        setError(null);

        try {
          const apiFormNames = formName.map((name) => formMappings[name]);

          const response = await apiClient.get(`ncr`, {
            params: {
              projectId,
              inspectionSupplier: supplier,
              inspectionShift: shift.join(","),
              date: startDate,
              endDate: endDate,
              formName: apiFormNames.join(","),
            },
          });

          if (
            response.data?.status === "success" &&
            Array.isArray(response.data.data)
          ) {
            const processedData = response.data.data.map((item) => ({
              ...item,
              remark: item.remark || "",
            }));
            setTableData(processedData);

            const uniqueApiSubForms = [
              ...new Set(
                processedData
                  .map((item) => item.subform || "")
                  .filter(Boolean)
              ),
            ];

            const orderedUiSubForms = [];
            const seen = new Set();

            for (const form of formName) {
              const subFormMap = subFormMappingsByForm[form] || {};
              for (const [uiName, apiName] of Object.entries(subFormMap)) {
                if (uniqueApiSubForms.includes(apiName) && !seen.has(uiName)) {
                  seen.add(uiName);
                  orderedUiSubForms.push(uiName);
                }
              }
            }

            setAvailableSubForms(orderedUiSubForms);
          } else {
            setError(response.data?.message || "Failed to fetch data");
            setTableData([]);
            setAvailableSubForms([]);
          }
        } catch (err) {
          setError("Failed to fetch data");
          console.error("Fetch error:", err);
          setTableData([]);
          setAvailableSubForms([]);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }, 400);

    return () => clearTimeout(timer);
  }, [endDate, supplier, shift, startDate, formName, projectId]);

  // Client-side subform filtering
  const filteredData = useMemo(() => {
    if (subForm.length === 0) return tableData;

    const selectedApiSubForms = subForm
      .map((ui) => allSubFormMappings[ui])
      .filter(Boolean);
    return tableData.filter((item) => selectedApiSubForms.includes(item.subform));
  }, [tableData, subForm, allSubFormMappings]);

  // Active form currently selected in Tabs
  const currentActiveForm = formName[selectedTab] || formName[0];

  // Robust function to identify which UI Form a record belongs to
  const getRowFormName = (item) => {
    // 1. Direct form property checking
    const itemForm = item.form_name || item.formName || item.form;
    if (itemForm) {
      if (inverseFormMappings[itemForm]) return inverseFormMappings[itemForm];
      if (formMappings[itemForm]) return itemForm;
    }

    // 2. Reverse lookup by subform property
    if (item.subform) {
      for (const [uiForm, subMap] of Object.entries(subFormMappingsByForm)) {
        if (Object.values(subMap).includes(item.subform)) {
          return uiForm;
        }
      }
    }

    return null;
  };

  // Tab-isolated dataset: Matches rows to active form, or safely falls back if forms aren't tagged
  const tabFilteredData = useMemo(() => {
    if (!currentActiveForm) return [];

    const matched = filteredData.filter((item) => {
      const detectedForm = getRowFormName(item);
      return detectedForm === currentActiveForm;
    });

    // If rows don't carry any form metadata, show filteredData rather than a blank screen
    return matched.length > 0 || filteredData.length === 0 ? matched : filteredData;
  }, [filteredData, currentActiveForm, inverseFormMappings]);

  // Tab Badge counts
  const formCounts = useMemo(() => {
    const counts = {};
    formName.forEach((f) => {
      const count = filteredData.filter((item) => getRowFormName(item) === f).length;
      counts[f] = count;
    });
    return counts;
  }, [formName, filteredData]);

  return (
    <Box sx={{ p: { xs: 2}, minHeight: "100%" }}>
      {/* Top Header Card */}
      <Paper
        elevation={0}
        sx={{
          px: 2,
          py: 1,
          mb: 2.5,
          borderRadius: 2,
          border: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1.5,
              bgcolor: "#eff6ff",
              color: "#2563eb",
              display: "flex",
            }}
          >
            <ReportIcon />
          </Box>
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 700, color: "#0f172a" }}
            >
              Non-Conformance Report
            </Typography>
            <Typography variant="caption" sx={{ color: "#64748b" }}>
              Tabbed breakdown of non-conformance records by form
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button
            size="small"
            variant="outlined"
            onClick={handleClearFilters}
            startIcon={<ResetIcon />}
            sx={{
              textTransform: "none",
              color: "#475569",
              borderColor: "#cbd5e1",
            }}
          >
            Reset
          </Button>
          <Button
            size="small"
            variant={showFilters ? "contained" : "outlined"}
            onClick={() => setShowFilters((prev) => !prev)}
            startIcon={showFilters ? <FilterListOffIcon /> : <FilterListIcon />}
            sx={{
              textTransform: "none",
              bgcolor: showFilters ? "#2563eb" : "transparent",
            }}
          >
            {showFilters ? "Hide Filters" : "Show Filters"}
          </Button>
        </Box>
      </Paper>

      {/* Filter Bar */}
      {showFilters && (
        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            mb: 3,
            borderRadius: 2,
            border: "1px solid #e2e8f0",
            bgcolor: "#ffffff",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(6, 1fr)",
              },
              gap: 2,
            }}
          >
            {/* 1. Supplier */}
            <CustomSingleSelect
              label="Supplier"
              value={supplier}
              options={allowedSuppliers.map((s) => ({
                value: s.name,
                label: s.name,
              }))}
              onChange={handleSupplierChange}
              placeholder="Select supplier"
            />

            {/* 2. Shift (Multi) */}
            <CustomMultiSelect
              label="Shift"
              options={supplierShifts}
              value={shift}
              onChange={setShift}
              disabled={!supplier}
              placeholder="Select shifts"
            />

            {/* 3. Start Date */}
            <CustomDateInput
              label="Start Date"
              value={startDate}
              onChange={setStartDate}
            />

            {/* 4. End Date */}
            <CustomDateInput
              label="End Date"
              value={endDate}
              onChange={setEndDate}
            />

            {/* 5. Form Name (Multi with Select All) */}
            <CustomMultiSelect
              label="Form Name"
              options={formNames}
              value={formName}
              onChange={handleFormNameChange}
              placeholder="Select forms"
            />

            {/* 6. Sub Form (Multi with Select All) */}
            <CustomMultiSelect
              label="Sub Form"
              options={availableSubForms}
              value={subForm}
              onChange={setSubForm}
              disabled={availableSubForms.length === 0}
              placeholder={
                availableSubForms.length === 0
                  ? "No subforms available"
                  : "Select subforms"
              }
            />
          </Box>
        </Paper>
      )}

      {/* Loading */}
      {loading && (
        <Box sx={{ py: 8, textAlign: "center" }}>
          <CircularProgress size={36} />
          <Typography variant="body2" sx={{ color: "#64748b", mt: 1.5 }}>
            Loading non-conformance records...
          </Typography>
        </Box>
      )}

      {/* Errors */}
      {error && (
        <Alert severity="error" sx={{ mb: 2.5, borderRadius: 2 }}>
          {error}
        </Alert>
      )}

      {/* Results View: Tabs & Table */}
      {!loading && formName.length > 0 ? (
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            border: "1px solid #e2e8f0",
            overflow: "hidden",
            bgcolor: "#ffffff",
          }}
        >
          {/* Scrollable Tabs */}
          <Box sx={{ borderBottom: "1px solid #e2e8f0", bgcolor: "#fcfdfd" }}>
            <Tabs
              value={selectedTab}
              onChange={(_, val) => setSelectedTab(val)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                px: 2,
                minHeight: 48,
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "13px",
                  minHeight: 48,
                },
              }}
            >
              {formName.map((name) => {
                const count = formCounts[name] ?? 0;
                return (
                  <Tab
                    key={name}
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>{name}</span>
                        <Chip
                          label={count}
                          size="small"
                          sx={{
                            height: 20,
                            fontSize: "11px",
                            fontWeight: 700,
                            bgcolor: count > 0 ? "#eff6ff" : "#f1f5f9",
                            color: count > 0 ? "#2563eb" : "#94a3b8",
                          }}
                        />
                      </Box>
                    }
                  />
                );
              })}
            </Tabs>
          </Box>

          {/* Table Container */}
          <Box sx={{ p: 2 }}>
            <Fade in={true} key={currentActiveForm}>
              <Box>
                <NonConformanceTable
                  data={tabFilteredData}
                  selectedForms={formName}
                  activeForm={currentActiveForm}
                  formMappings={formMappings}
                  selectedShifts={shift}
                />
              </Box>
            </Fade>
          </Box>
        </Paper>
      ) : (
        !loading && (
          <Paper
            elevation={0}
            sx={{
              py: 8,
              px: 3,
              textAlign: "center",
              borderRadius: 2,
              border: "1px dashed #cbd5e1",
              bgcolor: "#ffffff",
            }}
          >
            <TableIcon sx={{ fontSize: 36, color: "#94a3b8", mb: 1 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#334155" }}>
              No Forms Selected
            </Typography>
            <Typography variant="body2" sx={{ color: "#64748b" }}>
              Select a supplier and at least one Form Name above to view non-conformance data.
            </Typography>
          </Paper>
        )
      )}
    </Box>
  );
};

export default NonConfermanceReport;